import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { stockLevelActions } from "../slices/stockLevel";
import { getErrorMessage } from "../../utils/errorUtils";

import { StockLevelResponseDto } from "../../shared/dtos/stockLevel/StockLevelResponseDto";
import { StockAdjustmentRequestDto } from "../../shared/dtos/stockLevel/StockAdjustmentRequestDto";
import { StockLevelQueryParams } from "../../shared/dtos/stockLevel/StockLevelQueryParams";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getStockLevels =
  (params?: StockLevelQueryParams) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(stockLevelActions.setLoading());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<StockLevelResponseDto>>
      >("/stock-levels", {
        headers: { requiresAuth: true },
        params,
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(stockLevelActions.setItems(data.data.content));
        dispatch(stockLevelActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(stockLevelActions.setError(getErrorMessage(error)));
    }
  };

export const adjustStock =
  (values: StockAdjustmentRequestDto) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(stockLevelActions.setLoadingAdjust());
    try {
      const { data } = await axiosInstance.post<ApiResponseDto<void>>(
        "/stock-levels/adjust",
        values,
        {
          headers: { requiresAuth: true },
        },
      );
      if (data.status === ApiResponseStatus.SUCCESS) {
        toast.success(data.message || "Stock adjusted successfully!");
        dispatch(stockLevelActions.adjustStockSuccess());
        dispatch(
          stockLevelActions.setServerStatus({
            operation: "adjust",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(stockLevelActions.setErrorAdjust(message));
    }
  };

export const resetStockLevelServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(stockLevelActions.setServerStatus(null));
};
